// CUSTOM ANIMATIONS
// FADE-IN-UP ELEMENTS ON SCROLL
// YT VIDEO MODAL
// SLIDER (SWIPER JS)
// AUDIO PLAYER
// QUIZ
// DIALOGS (MODALS)
// PRODUCT PICKER
// LANSCAPE VIEWER (HOVER / SCROLL-X)


//
// =CUSTOM ANIMATIONS
// --------------------------------------------------

// splitting js
Splitting();

// gsap
// gsap.to(".msdw-cloud", {
//   scrollTrigger: {
//     scrub: true
//   },
//   y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
//   ease: "none"
// });

// gsap.from(".msdw-wolves img", {
//   opacity: 0,
//   scrollTrigger: {
//     trigger: ".msdw-wolves",
//     start: "top bottom",
//     end: "center center",
//     scrub: true
//   },
// });

const zoomOutTriggers = document.querySelectorAll('.msdw-zoom-out-trigger');

zoomOutTriggers.forEach(zoomOutTrigger => {
  const zoomOut = zoomOutTrigger.querySelector(".msdw-zoom-out");

  gsap.from( zoomOut, {
    scale: 1.15,
    scrollTrigger: {
      trigger: zoomOutTrigger,
      start: "top 66%",
      end: "top 15%",
      scrub: true,
      ease: 'Power0',
      // markers: true,
    }
  });
});

// gsap.utils.toArray(".msdw-zoom-out-trigger").forEach(zoomOutTrigger => {
//   let zoomOut = zoomOutTrigger.querySelector(".msdw-zoom-out");

//   gsap.from( zoomOut, {
//     scale: 1.15,
//     scrollTrigger: {
//       trigger: zoomOutTrigger,
//       start: "top 66%",
//       end: "top 15%",
//       scrub: true,
//       ease: 'Power0',
//       // markers: true,
//     }
//   });
// });

const revealTriggers = document.querySelectorAll('.msdw-reveal-trigger');

revealTriggers.forEach(revealTrigger => {
  const reveal = revealTrigger.querySelector(".msdw-reveal");

  gsap.to( reveal, {
    clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
    scrollTrigger: {
      trigger: revealTrigger,
      start: "top 75%",
      ease: 'Expo',
      once: true,
    }
  });
});

// gsap.utils.toArray(".msdw-reveal-trigger").forEach(revealTrigger => {
//   let reveal = revealTrigger.querySelector(".msdw-reveal");

//   gsap.to( reveal, {
//     clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
//     scrollTrigger: {
//       trigger: revealTrigger,
//       start: "top 75%",
//       ease: 'Expo',
//       once: true,
//     }
//   });
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));


//
// =YT VIDEO MODAL
// --------------------------------------------------

$(".js-trigger-video-modal")
  .on("click", function(e){
    e.preventDefault();
    var id = $(this).attr('data-youtube-id');
    // var enablejsapi = '?enablejsapi=1';
    var autoplay = '?autoplay=1';
    var related_no = '&rel=0';
    var captions = '&cc_load_policy=1';
    // var src = '//www.youtube.com/embed/'+id+enablejsapi+autoplay+related_no;
    var src = '//www.youtube.com/embed/'+id+autoplay+related_no+captions;
    // console.log(src);

    $("#youtube").attr('src', src);
    // $("body").addClass("show-video-modal noscroll");
  });

function close_video_modal() {
//   $("body").removeClass("show-video-modal noscroll");
  $("#youtube").attr('src', '');
  dialog.close();
}

$('body').on('click', '.dialog-close', function(event) {
  close_video_modal();
});

$('body').keyup(function(e) {
  if (e.keyCode == 27) {
    close_video_modal();
  }
});


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

$('.msdw-filter-wrapper').on( 'click', 'div', function() {
  var filter = $(this).attr('data-filter');

  $('.msdw-slider-products .swiper-slide').css('display', 'none')
  $('.msdw-slider-products .swiper-slide' + filter).css('display', '')
  $( '.msdw-filter-wrapper div' ).removeClass( 'msdw-filter-active' );
  $( this ).addClass( 'msdw-filter-active' );

  sliderProducts.updateSize();
  sliderProducts.updateSlides();
  sliderProducts.updateProgress();
  sliderProducts.updateSlidesClasses();
  sliderProducts.slideTo(0);

  return false;
});

var sliderProducts = new Swiper('#sliderProducts', {
  slidesPerView: 1.67,
  spaceBetween: 10,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3.333,
      spaceBetween: 20,
    },
    1480: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});

var sliderModal = new Swiper('#sliderModal', {
  slidesPerView: 1,
  loop: false,
  navigation: {
    nextEl: '.msdw-swiper-button-next',
    prevEl: '.msdw-swiper-button-prev',
  },
});


//
// =AUDIO PLAYER
// --------------------------------------------------

let currentButton;
let audioPlaying = false;

const playAudio = function (audioPath) {
  if (audioPlaying == false) {
    audio.src = audioPath;
    audioPlaying = true;
    this.querySelector('svg use').setAttribute('href', '#msdw-icon--audio-playing');
  } else if (currentButton == this && audioPlaying == true) {
    audio.pause();
    audioPlaying = false;
    this.querySelector('svg use').setAttribute('href', '#msdw-icon--audio');
  } else if (currentButton != this) {
    audio.src = audioPath;
    audioPlaying = true;
    currentButton.querySelector('svg use').setAttribute('href', '#msdw-icon--audio');
    this.querySelector('svg use').setAttribute('href', '#msdw-icon--audio-playing');
  }

  currentButton = this;

  audio.addEventListener('ended', () => {
    audioPlaying = false;
    currentButton.querySelector('svg use').setAttribute('href', '#msdw-icon--audio');
  });
}

const audioWrappers = document.querySelectorAll('.msdw-player-wrapper');

audioWrappers.forEach(audioWrapper => {
  audioWrapper.addEventListener('click', () => {
    playAudio.call(audioWrapper, audioWrapper.dataset.audio);
  });
});


//
// =QUIZ
// --------------------------------------------------

const quizListOptions = document.querySelectorAll('.msdw-quiz-list li');

quizListOptions.forEach(quizListOption => {
  quizListOption.addEventListener('click', () => {
    if (quizListOption.classList.contains('msdw-quiz-right-answer')) {
      quizListOption.closest('section').classList.add('msdw-right-answer');
    } else {
      quizListOption.closest('section').classList.add('msdw-wrong-answer');
    }
  })
});


//
// =DIALOGS (MODALS)
// --------------------------------------------------

// Get all links that start with #modal
const modalLinks = document.querySelectorAll('a[href^="#modal"]');

modalLinks.forEach(function (modalLink, index) {
  // Get modal ID to match the modal
  const modalId = modalLink.getAttribute('href');

  // Click on link
  modalLink.addEventListener('click', function (event) {

    // Get modal element
    const modal = document.querySelector(modalId);
    // If modal with an ID exists
    if(modal){
      // Get close button
      const closeBtn = modal.querySelector('.dialog-close');
      event.preventDefault();
      modal.showModal(); // Open modal

      // Close modal on click
      closeBtn.addEventListener('click', function (event) {
        modal.close();
      });

      // Close modal when clicking outside modal
      document.addEventListener('click', function (event) {

        const dialogEl = event.target.tagName;
        const dialogElId = event.target.getAttribute('id');
        if(dialogEl == 'DIALOG'){
          // Close modal
          modal.close();
        }
      }, false);

    // If modal ID not exists
    } else {
      console.log('Modal doesn\'t exist');
    }
  });
});


//
// =PRODUCT PICKER
// --------------------------------------------------

const productPickers = document.querySelectorAll('.msdw-product-detail-picker');

productPickers.forEach(productPicker => {
  const productIdNumber = productPicker.dataset.productId;
  productPicker.addEventListener('click', (e) => {
    e.preventDefault();
    window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {
      'productId': productIdNumber
    });
  });
});


//
// =LANSCAPE VIEWER (HOVER / SCROLL-X)
// --------------------------------------------------

let animating = true;

function lerp(start, end, t){
  return start * (1 - t) + end * t;
}

let mouseCoordinates = {
  x: 0,
  y: 0,
  targetX: 0,
  targetY: 0
}

document.querySelector('.msdw-landscape-viewer').addEventListener('mousemove', (e) => {
  // mouseCoordinates.targetX = (e.clientX - (window.innerWidth / 2))
  // mouseCoordinates.targetY = (e.clientY - (window.innerHeight / 2))
  mouseCoordinates.targetX = (e.clientX / 2.25)
  mouseCoordinates.targetY = (e.clientY / 2.25)
});

function animate(){
  if (animating) {
    mouseCoordinates.x = lerp(mouseCoordinates.x, mouseCoordinates.targetX, .075);
    let {x, y} = mouseCoordinates;
    // document.querySelector('.msdw-landscape-img').style.transform = `translate3d(${-x}px, ${-y}px, 0)`
    document.querySelector('.msdw-landscape-img').style.transform = `translate3d(${-x}px, 0, 0)`
  }
  window.requestAnimationFrame(animate);
}

animate();
